import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { UiTabColorType } from "../../models/tab.models";

@Component({
  selector: "ui-tab-color-indicator",
  template: "<div></div>",
  styleUrls: ["tab-color-indicator.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UiTabColorIndicatorComponent {
  @Input() public color: UiTabColorType;

  @HostBinding("class")
  public get hostClasses(): string[] {
    return ["ui-tab-color-indicator", `ui-tab-color-indicator-${this.color}`];
  }
}
